import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './CookieConsent.css';

export const COOKIE_CONSENT_KEY = 'help2fix_cookie_consent_v1';
export const OPEN_COOKIE_SETTINGS_EVENT = 'help2fix:open-cookie-settings';
const ACCEPTED_CONSENT_TTL = 365 * 24 * 60 * 60 * 1000;
const REJECTED_CONSENT_TTL = 180 * 24 * 60 * 60 * 1000;

export const getCookieConsentChoice = () => {
    try {
        const consent = JSON.parse(localStorage.getItem(COOKIE_CONSENT_KEY));
        if (!['all', 'necessary'].includes(consent?.choice)) return null;
        if (!consent.expiresAt || Date.parse(consent.expiresAt) <= Date.now()) {
            localStorage.removeItem(COOKIE_CONSENT_KEY);
            return null;
        }
        return consent.choice;
    } catch {
        localStorage.removeItem(COOKIE_CONSENT_KEY);
        return null;
    }
};

const CookieConsent = () => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(() => !getCookieConsentChoice());

    useEffect(() => {
        const openSettings = () => setIsOpen(true);
        window.addEventListener(OPEN_COOKIE_SETTINGS_EVENT, openSettings);
        return () => window.removeEventListener(OPEN_COOKIE_SETTINGS_EVENT, openSettings);
    }, []);

    const saveConsent = choice => {
        const previousChoice = getCookieConsentChoice();
        const ttl = choice === 'all' ? ACCEPTED_CONSENT_TTL : REJECTED_CONSENT_TTL;
        const now = new Date();
        localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({
            choice,
            updatedAt: now.toISOString(),
            expiresAt: new Date(now.getTime() + ttl).toISOString()
        }));
        window.dispatchEvent(new CustomEvent('help2fix:cookie-consent-changed', {
            detail: { choice }
        }));
        setIsOpen(false);
        if (previousChoice === 'all' && choice === 'necessary') {
            window.setTimeout(() => window.location.reload(), 50);
        }
    };

    if (!isOpen) return null;

    return (
        <section className="cookie-consent" role="dialog" aria-live="polite" aria-label={t('CookieConsentTitle')}>
            <div className="cookie-consent__inner">
                <div className="cookie-consent__copy">
                    <h2><i className="icon-material-outline-lock"></i> {t('CookieConsentTitle')}</h2>
                    <p>
                        {t('CookieConsentText')}{' '}
                        <NavLink to="/privacy-policy">{t('LearnMore')}</NavLink>
                    </p>
                </div>
                <div className="cookie-consent__actions">
                    <button type="button" className="cookie-consent__button" onClick={() => saveConsent('necessary')}>
                        {t('CookieNecessaryOnly')}
                    </button>
                    <button type="button" className="cookie-consent__button" onClick={() => saveConsent('all')}>
                        {t('CookieAcceptAll')}
                    </button>
                </div>
            </div>
        </section>
    );
};

export default CookieConsent;
